﻿import { React, useState, useEffect } from "react";
import { 
  setSelectedWorkflow,
  selectWorkflow
} from "@/features/homepage/workflowManagerSessionSlice";
import "./WorkflowSummary.css";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import WorkflowManagerPage from "./WorkflowManagerPage";
import WorkFlowSummary from "./WorkflowSummary";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
const WorkflowManagerTab = () => {
  const dispatch = useDispatch();
  const selectedWorkflow = useSelector(selectWorkflow);
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    if (selectedWorkflow !== 0 && tabValue === 0) {
      setTabValue(1);
    } else if (selectedWorkflow === 0 && tabValue !== 0) {
      setTabValue(0);
    }
  }, [selectedWorkflow, tabValue]);

  const resetWorkflow = () => {
    dispatch(setSelectedWorkflow({ selectedWorkflow: 0 }));
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    if (newValue === 0) {
      resetWorkflow();
    }
  };

  return (
    <>
      <ShepTabs
        value={tabValue}
        onChange={handleTabChange}
        aria-label="workflow tabs"
        className="workflow-tabs"
        variant="tertiary"
        sx={{
          backgroundColor: "var(--default-light)",
          height: "78px",
        }}
      >
        <ShepTab variant="tertiary" label="Summary" sx={{ width: 225 }} />
        <ShepTab
          variant="tertiary"
          label="Manager"
          disabled={selectedWorkflow === 0}
          sx={{ width: 225 }}
        />
      </ShepTabs>

      {/* SHEP-117: Show settings button only when there a workflow selected */}

      {tabValue === 0 ? <WorkFlowSummary /> : <WorkflowManagerPage />}
    </>
  );
};

export default WorkflowManagerTab;
